module.exports = __webpack_public_path__ + "static/media/LogoBeta.69ec354c.svg";